import React, { useCallback, useEffect } from "react";
import { Box, Divider, Typography } from "@material-ui/core";
import {
  CustomInput,
  CustomSwitch,
  CustomTextArea,
} from "../../../../../../../../Components";
import { useQuery, useTranslate } from "../../../../../../../../Hooks";
import {
  GetpropertyIdImageInfoByImageInfoId,
  GetUnitImageInfoByImageInfoId,
} from "../../../../../../../../Services";

// styles
import useStyles from "./styles";

function ImagePublishDetailsComponent({
  activeImage,
  state,
  setstateData,
  data,
  defaultData,
}) {
  const styles = useStyles();
  const { translate } = useTranslate("NewPropertiesView");
  const query = useQuery();
  const pathName = window.location.pathname
    .split("/home/")[1]
    .split("/view")[0];

  const GetUnitImageInfoByImageInfoIdAPI = useCallback(
    async ({ unitId, fileId, categoryId }) => {
      const res =
        pathName === "Properties-CRM/property-profile-overview"
          ? await GetpropertyIdImageInfoByImageInfoId(
              unitId,
              fileId,
              categoryId
            )
          : await GetUnitImageInfoByImageInfoId(unitId, fileId, categoryId);
      if (!(res && res.status && res.status !== 200)) {
        if (res === "") {
          setstateData({
            ...defaultData,
            imageTitle: activeImage.categoryName,
            imageDescription: activeImage.categoryName,
            propertyId: query.get("id"),
          });
        } else {
          setstateData(res.length === 0 ? defaultData : res);
        }
      } else {
        setstateData(res);
      }
    },
    [data, defaultData]
  );

  useEffect(() => {
    if (data) {
      GetUnitImageInfoByImageInfoIdAPI({
        unitId: (data && data.unitId) || query.get("id"),
        fileId: (activeImage && activeImage.fileId) || null,
        categoryId: (data && data.categoryId) || null,
      });
    }
  }, [data, activeImage]);

  useEffect(() => {
    if (state.isPublished === false)
      setstateData((item) => ({ ...item, isMarketing: false }));
  }, [state.isPublished]);

  return (
    <Box className={styles.containerFileds}>
      <Box className={styles.containerFiledItem}>
        <Typography className={styles.titleItem}>
          {translate("Image-title")}
        </Typography>
        <CustomInput
          hasSearchIcon={false}
          style={{ maxWidth: "100%" }}
          placeholder={translate("Enter")}
          onChange={(e) => {
            setstateData((item) => ({ ...item, imageTitle: e?.target?.value }));
          }}
          value={state?.imageTitle}
        />
      </Box>

      <Divider />

      <Box className={styles.containerFiledItem}>
        <Typography className={styles.titleItem}>
          {translate("Property-description")}
        </Typography>
        <CustomTextArea
          maxRows={5}
          minRows={5}
          placeholder={translate("Remark")}
          onInputChange={(value) => {
            setstateData((item) => ({ ...item, imageDescription: value }));
          }}
          value={state?.imageDescription || ""}
        />
      </Box>

      <Divider />

      <Box className={styles.containerFiledItem}>
        <Typography className={styles.titleItem}>
          {translate("Is-published")}
        </Typography>
        <CustomSwitch
          size={"md"}
          label={translate("Published-in-portal")}
          checked={state?.isPublished}
          onChange={(e) => {
            const isChecked = e.target.checked;
            setstateData((item) => ({ ...item, isPublished: isChecked }));
          }}
          isDisabled={false}
        />
      </Box>

      <Divider />

      <Box className={styles.containerFiledItem}>
        <Typography className={styles.titleItem}>
          {translate("Is-marketing")}
        </Typography>
        <CustomSwitch
          size={"md"}
          label={translate("For-marketing-purposes")}
          checked={state.isMarketing}
          onChange={(e) => {
            const isChecked = e?.target?.checked;
            setstateData((item) => ({ ...item, isMarketing: isChecked }));
          }}
          isDisabled={state.isPublished === false}
        />
      </Box>

      <Divider />

      <Box className={styles.containerFiledItem}>
        <Typography className={styles.titleItem}>
          {translate("Need-owner-approval")}
        </Typography>
        <Box className={styles.containerSwitchButtons}>
          <CustomSwitch
            size={"md"}
            label={translate("approval-needed")}
            checked={state?.isNeedOwnerApproval}
            onChange={(e) => {
              const isChecked = e.target.checked;
              setstateData((item) => ({
                ...item,
                isNeedOwnerApproval: isChecked,
              }));
            }}
            isDisabled={false}
          />
          {state && state.isNeedOwnerApproval && (
            <CustomSwitch
              size={"md"}
              label={translate("Is-approved")}
              checked={state?.isApproved}
              onChange={(e) => {
                const isChecked = e.target.checked;
                setstateData((item) => ({ ...item, isApproved: isChecked }));
              }}
              isDisabled={false}
            />
          )}
        </Box>
      </Box>

      <Divider />

      <Box className={styles.containerFiledItem}>
        <Typography className={styles.titleItem}>
          {translate("Comments")}
        </Typography>
        <CustomTextArea
          maxRows={5}
          minRows={5}
          placeholder={translate("Remark")}
          onInputChange={(value) => {
            setstateData((item) => ({ ...item, comments: value }));
          }}
          value={state?.comments || ""}
        />
      </Box>
    </Box>
  );
}

export default ImagePublishDetailsComponent;
